<h3 mat-dialog-title>Entity Edit</h3>
<mat-dialog-content style="max-height: unset!important;">

    <mat-tab-group class="entityGroup" mat-align-tabs="start" [selectedIndex]="this.data['selectedTab']" (selectedTabChange)="tabChange($event)">
        <mat-tab label="Service Landscape">
            <ng-template matTabContent>
                <div class="aip-woptions-sidebar">


                    <div class="sidebar-column">
                        <div>
                            <label>Area</label>
                            <ng-select class="aip-select" [clearable]="false" appendTo="#selectOverlayDiv"
                                [items]="useNewLayout ? newLayoutAreas : oldLayoutAreas" [(ngModel)]="this.data['area']" (change)="updateDisplayOrder()">
                            </ng-select>
                        </div>
                        <div>
                            <label>Order In Area</label>
                            <ng-select class="aip-select" [clearable]="false" appendTo="#selectOverlayDiv"
                                [items]="this.displayorderList" [(ngModel)]="this.data['displayorder']">
                            </ng-select>
                        </div>
                    </div>

                    <div style="clear: both;">
                        <label>Status</label>
                        <ng-select class="aip-select" [clearable]="false" appendTo="#selectOverlayDiv"
                            [items]="this.statuses" [(ngModel)]="this.data['status']" (change)="triggerEntityOnChanges()">
                        </ng-select>
                    </div>

                    <div>
                        <label>Service Name</label>
                        <input matInput type="text" class="aip-input" [(ngModel)]="this.data['servicename']" />
                    </div>

                    <div class="sidebar-column">
                        <div>
                            <label>Primary Technology</label>
                            <!-- <input matInput type="text" class="aip-input" [(ngModel)]="this.data['primarytechnology']"/> -->
                            <ng-select class="aip-select" appendTo="#selectOverlayDiv" [addTag]="true"
                                [items]="this.logosData" [(ngModel)]="this.data['primarytechnology']" bindLabel="name"
                                bindValue="name" (change)="triggerEntityOnChanges()">
                            </ng-select>
                        </div>

                        <div>
                            <label>Secondary Technology</label>
                            <!-- <input matInput type="text" class="aip-input" [(ngModel)]="this.data['secondarytechnology']"/> -->
                            <ng-select class="aip-select" appendTo="#selectOverlayDiv" [addTag]="true"
                                [items]="this.logosData" [(ngModel)]="this.data['secondarytechnology']" bindLabel="name"
                                bindValue="name" (change)="triggerEntityOnChanges()">
                            </ng-select>
                        </div>
                    </div>

                    <div class="sidebar-column">
                        <div>
                            <label>Provider</label>
                            <ng-select class="aip-select" appendTo="#selectOverlayDiv" [addTag]="true"
                                [items]="this.logosData" [(ngModel)]="this.data['provider']" bindLabel="name"
                                bindValue="name" (change)="triggerEntityOnChanges()">
                            </ng-select>
                        </div>
                        <div>
                            <label>Client Funded</label>
                            <ng-select class="aip-select" appendTo="#selectOverlayDiv" [clearable]="false"
                                [addTag]="true" [items]="['','Yes','No']" [(ngModel)]="this.data['clientfunded']">
                            </ng-select>
                        </div>
                    </div>

                    <div class="sidebar-column" style="align-items: flex-end;">
                        <div>
                            <label>Coverage (%)</label>
                            <input matInput type="text" digitOnly [min]=0 [max]=100 class="aip-input"
                                [(ngModel)]="this.data['coverage']" />
                        </div>

                        <div>
                            <label matTooltip="EOL - % of estate that is End of Life">EOL</label>
                            <input matInput type="text" digitOnly [min]=0 [max]=100 class="aip-input"
                                [(ngModel)]="this.data['assetlifecycle']" />
                        </div>
                    </div>

                    <div class="sidebar-column">
                        <div>
                            <label matTooltip="Years since bid loss or DXC service ended">Years Lost<mat-icon svgIcon="toggle-icon" aria-hidden="false" class="toggle-icon" [matTooltip]="'Toggle to ' + (enableYearLostPicker ? 'year input' : 'datepicker')" (click)="toggleDatePicker('enableYearLostPicker')"></mat-icon></label>
                            <input *ngIf="!enableYearLostPicker" matInput type="text" digitOnly [min]="0" [max]="maxYearDiff" class="aip-input" autocomplete="off" [(ngModel)]="data.yearslostNum" (change)="changeYearInput('yearslost')" />
                            <ng-container *ngIf="enableYearLostPicker">
                                <input matInput class="aip-input" style="width: 105px;" autocomplete="off" [matDatepicker]="yearLostPicker" [matDatepickerFilter]="datePickerFilter" [(ngModel)]="data.yearslost" (dateChange)="changeDatePicker('yearslost', $event)">
                                <mat-datepicker-toggle matSuffix [for]="yearLostPicker" class="custom-datepicker-toggle"></mat-datepicker-toggle>
                                <mat-datepicker #yearLostPicker></mat-datepicker>
                            </ng-container>
                        </div>

                        <div>
                            <label matTooltip="Years since service provider change">Tenure Of Service<mat-icon svgIcon="toggle-icon" aria-hidden="false" class="toggle-icon" [matTooltip]="'Toggle to ' + (enableTenurePicker ? 'year input' : 'datepicker')" (click)="toggleDatePicker('enableTenurePicker')"></mat-icon></label>
                            <input *ngIf="!enableTenurePicker" matInput type="text" digitOnly [min]="0" [max]="maxYearDiff" class="aip-input" autocomplete="off" [(ngModel)]="data.servicetenureNum" (change)="changeYearInput('servicetenure')" />
                            <ng-container *ngIf="enableTenurePicker">
                                <input matInput class="aip-input" style="width: 105px;" autocomplete="off" [matDatepicker]="tenurePicker" [matDatepickerFilter]="datePickerFilter" [(ngModel)]="data.servicetenure" (dateChange)="changeDatePicker('servicetenure', $event)">
                                <mat-datepicker-toggle matSuffix [for]="tenurePicker" class="custom-datepicker-toggle"></mat-datepicker-toggle>
                                <mat-datepicker #tenurePicker></mat-datepicker>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="aip-woptions-main">
                    <div class="aip-options">

                        <ng-container>
                            <div class="">
                                <ng-container *ngIf="useNewLayout; else oldEntityComponent">
                                    <app-entity-new [data]="this.data" viewType="landscape"></app-entity-new>
                                </ng-container>
                                <ng-template #oldEntityComponent>
                                    <app-entity [data]="this.data" viewType="landscape"></app-entity>
                                </ng-template>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="landscapeNotes" [ngStyle]="{'display': this.data.id||this.data['area']?'block':'none'}">
                    <div>
                        <label>Notes&nbsp;&nbsp;<fa-icon *ngIf="this.data['area']&&slNewNoteDisplay" [matTooltip]="Save" class="saveNewNoteBt" icon="save" (click)="saveNote('landscape')"></fa-icon></label>
                         <!-- <button mat-icon-button onclick="this.blur()" (click)="openNotes('landscape')" [autofocus]="false">
                            <mat-icon style="color: rgba(0,0,0,.87);padding-bottom: 5px;">add</mat-icon>
                        </button>  -->
                        <div style="width: 300px;">
                            <div id="addSlNote"></div>
                            <!-- <div *ngIf="!isRichText" (click)="changeTextInput()" class="newNoteContainer">
                                <div *ngIf="!slNewNote" style="color:#D4D4D4">Add a service landscape note</div>
                                <div *ngIf="slNewNote" [innerHTML]="slNewNote">Add a service landscape note</div>
                            </div> -->
                            <!-- <textarea *ngIf="!isRichText" class="aip-input" placeholder="Add a service landscape note" (focus)="changeTextInput()" style="height: 80px"></textarea> -->
                          </div>
                        <div *ngIf="this.landscapeView.length>0" class="landscapeNoteMessage">
                            <label>Recent Note</label>
                            <div class="noteMessage">
                                <div class="messageTitle">
                                    {{this.landscapeView[this.landscapeView.length-1].createdby}}
                                    &nbsp;&nbsp;
                                    {{this.landscapeView[this.landscapeView.length-1].created | date: 'yyyy-MM-dd'}}
                                    <ng-container *ngIf="!this.landscapeView[this.landscapeView.length-1]['isEdit']&&this.landscapeView[this.landscapeView.length-1].createdby==this.user.username">
                                        <fa-icon class="btFloat" [matTooltip]="Edit" icon="edit" (click)="eidtLatestNote(this.landscapeView[this.landscapeView.length-1], 'latestSlNote')"></fa-icon>
                                        <fa-icon class="btStyle deleteBtColor btFloat" [matTooltip]="Delete" icon="trash-alt" (click)="deleteNote(this.landscapeView[this.landscapeView.length-1])"></fa-icon>
                                    </ng-container>
                                    <ng-container *ngIf="this.landscapeView[this.landscapeView.length-1]['isEdit']&&this.landscapeView[this.landscapeView.length-1].createdby==this.user.username">
                                        <fa-icon class="btFloat" [matTooltip]="Cancel" icon="times-circle" (click)="cancelUpdate(this.landscapeView[this.landscapeView.length-1])"></fa-icon>
                                        <fa-icon *ngIf="this.landscapeView[this.landscapeView.length-1]['saveBtDisplay']" class="btStyle saveBtColor btFloat" [matTooltip]="Save" icon="save"  (click)="updateNote(this.landscapeView[this.landscapeView.length-1])"></fa-icon>
                                    </ng-container>
                                </div>
                                <div *ngIf="this.landscapeView[this.landscapeView.length-1]['isEdit']" id="latestSlNote"></div>
                                <div style="padding:0px 10px 10px 10px" *ngIf="!this.landscapeView[this.landscapeView.length-1]['isEdit']"><p [innerHTML]="this.landscapeView[this.landscapeView.length-1].comment" [matTooltip]="'createdBy:' + this.landscapeView[this.landscapeView.length-1].createdby + '\n' + 'createdOn:' + this.landscapeView[this.landscapeView.length-1].created"></p></div>
                            </div>
                        </div>
                    </div>
                    
                </div>


            </ng-template>
        </mat-tab>

        <mat-tab label="Health View">
            <ng-template matTabContent>

                <div class="aip-woptions-sidebar">


                    <div>
                        <label>Health Status</label>
                        <ng-select class="aip-select" [clearable]="true" appendTo="#selectOverlayDiv"
                            [items]="this.healthStatuses" [(ngModel)]="this.data['healthstatus']" (change)="triggerEntityOnChanges()">
                        </ng-select>
                    </div>

                    <div>
                        <label>Trend</label>
                        <ng-select class="aip-select" [clearable]="false" appendTo="#selectOverlayDiv"
                            [items]="this.healthTrends" [(ngModel)]="this.data['healthtrend']" (change)="triggerEntityOnChanges()">
                        </ng-select>
                    </div>

                    <div class="sidebar-column">
                        <div>
                            <label matTooltip="EOL - % of estate that is End of Life">EOL</label>
                            <input matInput type="text" digitOnly [min]=0 [max]=100 class="aip-input readonly"
                                [value]="this.data['assetlifecycle']?this.data['assetlifecycle']:''" readonly />
                        </div>

                        <div>
                            <label matTooltip="EOSL - % of estate that is End of Service Life (%)">EOSL</label>
                            <input matInput type="text" digitOnly [min]=0 [max]=100 class="aip-input"
                                [(ngModel)]="this.data['healtheosl']" />
                        </div>
                    </div>

                </div>

                <div class="aip-woptions-main">
                    <div class="aip-options">

                        <ng-container>
                            <div class="" style="margin-right: 3px;">
                                <ng-container *ngIf="useNewLayout; else oldEntityTemplate">
                                    <app-entity-new [data]="this.data" viewType="health"></app-entity-new>
                                </ng-container>
                                <ng-template #oldEntityTemplate>
                                    <app-entity [data]="this.data" viewType="health"></app-entity>
                                </ng-template>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <div class="healthNotes" *ngIf="this.data.id||this.data['area']">
                    <label>Notes&nbsp;&nbsp;<fa-icon *ngIf="this.data['area']&&hvNewNoteDisplay" [matTooltip]="Save" class="saveNewNoteBt" icon="save" (click)="saveNote('healthView')"></fa-icon></label>
                    <div id="addHvNote"></div>
                    <div *ngIf="this.healthView.length>0" class="healthViewNoteMessage">
                        <label>Recent Note</label>
                        <div class="noteMessage">
                            <div class="messageTitle">
                                {{this.healthView[this.healthView.length-1].createdby}}
                                &nbsp;&nbsp;
                                {{this.healthView[this.healthView.length-1].created | date: 'yyyy-MM-dd'}}
                                <ng-container *ngIf="!this.healthView[this.healthView.length-1]['isEdit']&&this.healthView[this.healthView.length-1].createdby==this.user.username">
                                    <fa-icon class="btFloat" [matTooltip]="Edit" icon="edit" (click)="eidtLatestNote(this.healthView[this.healthView.length-1], 'latestHvNote')"></fa-icon>
                                    <fa-icon class="btStyle deleteBtColor btFloat" [matTooltip]="Delete" icon="trash-alt" (click)="deleteNote(this.healthView[this.healthView.length-1])"></fa-icon>
                                </ng-container>
                                <ng-container *ngIf="this.healthView[this.healthView.length-1]['isEdit']&&this.healthView[this.healthView.length-1].createdby==this.user.username">
                                    <fa-icon class="btFloat" [matTooltip]="Cancel" icon="times-circle" (click)="cancelUpdate(this.healthView[this.healthView.length-1])"></fa-icon>
                                    <fa-icon *ngIf="this.healthView[this.healthView.length-1]['saveBtDisplay']" class="btStyle saveBtColor btFloat" [matTooltip]="Save" icon="save"  (click)="updateNote(this.healthView[this.healthView.length-1])"></fa-icon>
                                </ng-container>
                            </div>
                            <div *ngIf="this.healthView[this.healthView.length-1]['isEdit']" id="latestHvNote"></div>
                            <div style="padding:0px 10px 10px 10px" *ngIf="!this.healthView[this.healthView.length-1]['isEdit']"><p [innerHTML]="this.healthView[this.healthView.length-1].comment"></p></div>
                        </div>
                        <!-- <div style="float: right;">
                            <button mat-icon-button (click)="deleteNote(this.healthView[this.healthView.length-1])">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div> -->
                    </div>
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab label="All Notes" *ngIf="this.data.id||this.data['area']">
            <ng-template matTabContent>
                <div class="generalNotes">
                    <!-- <div id="addGeNote" style="margin-top:15px;"></div> -->
                    <fa-icon *ngIf="this.data['area']&&geNewNoteDisplay" [matTooltip]="Save" style="top:-103px; display:flex" class="saveNewNoteBt" icon="save" (click)="saveNote('general')"></fa-icon>
                        <div *ngIf="this.allViews.length>0">
                            <div class="noteTypeExplain">
                                <div class="noteType" style="background-color: #FFC000;" (click)="selectType('slSelected')"><fa-icon *ngIf="this.slSelected" icon="check-circle" class="selectedIcon"></fa-icon>Service Landscape</div>
                                <div class="noteType" style="background-color: #92D050;" (click)="selectType('hvSelected')"><fa-icon *ngIf="this.hvSelected" icon="check-circle" class="selectedIcon"></fa-icon>Health View</div>
                                <!-- <div>
                                  <div class="noteType" style="background-color: #33CCFF;" (click)="selectType('geSelected')"><fa-icon *ngIf="this.geSelected" icon="check-circle" class="selectedIcon"></fa-icon>General</div>
                                </div> -->
                            </div>
                            <div class="noteMessage healthViewNoteMessage generalNoteMessage" [ngStyle]="{'border-color': getNoteColor(note)}" *ngFor="let note of this.selectedViews">
                                <div class="messageTitle">
                                    {{note.createdby}}
                                    &nbsp;&nbsp;
                                    {{note.created | date: 'yyyy-MM-dd'}}
                                    <span style="margin-left:40px;">{{this.data['servicename']}}</span>
                                    <ng-container *ngIf="!note['isEdit']&&note.createdby==this.user.username">
                                        <fa-icon class="btFloat" [matTooltip]="Edit" icon="edit" (click)="eidtLatestNote(note, 'note'+note.id)"></fa-icon>
                                        <fa-icon class="btStyle deleteBtColor btFloat" [matTooltip]="Delete" icon="trash-alt" (click)="deleteNote(note)"></fa-icon>
                                    </ng-container>
                                    <ng-container *ngIf="note['isEdit']&&note.createdby==this.user.username">
                                        <fa-icon class="btFloat" [matTooltip]="Cancel" icon="times-circle" (click)="cancelUpdate(note)"></fa-icon>
                                        <fa-icon *ngIf="note['saveBtDisplay']" class="btStyle saveBtColor btFloat" [matTooltip]="Save" icon="save"  (click)="updateNote(note)"></fa-icon>
                                    </ng-container>
                                </div>
                                <div *ngIf="!note['isEdit']" class="noteContent"><p [innerHTML]="note.comment"></p></div>
                                <div *ngIf="note['isEdit']" [id]="'note'+note.id"></div>
                            </div>
                            <!-- <div style="float: right;">
                                <button mat-icon-button (click)="deleteNote(this.healthView[this.healthView.length-1])">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div> -->
                        </div>
                </div>
            </ng-template>
        </mat-tab>

    </mat-tab-group>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" class="aip-button" (click)="save('bottom')" [mat-dialog-close]="data"
        cdkFocusInitial>OK</button>
    <button *ngIf="data['id']!=undefined" mat-raised-button color="warn" class="aip-button"
        (click)="delete()">Delete</button>
    <button mat-raised-button class="aip-button-alt" (click)="close()">Cancel</button>
</mat-dialog-actions>


<!-- Overlay for the dropdowns -->
<div id="selectOverlayDiv" #selectOverlay class="aip-select-overlay" style="position: absolute;"></div>
